module.exports = __webpack_public_path__ + "img/full0-min.cae9d85c.png";